export default {
  lockScreen: '锁定屏幕',
  lock: '锁定',
  lockPassword: '锁屏密码',
  unlock: '点击解锁',
  backToLogin: '返回登录',
  entrySystem: '进入系统',
  placeholder: '请输入锁屏密码',
  message: '锁屏密码错误'
}